import { PartiallyOptional } from "@/types/utils.types";
import { IAlertToastProps } from "@/components/common/AlertToast/AlertToast.types";
import { IErrorPageProps } from "@/components/common/ErrorPage/ErrorPage.types";
import {
  HIDE_TOAST,
  SET_USER_JOIN_LEAVE_NOTIFICATION,
  SET_WHITE_LABEL_ENABLED,
  SHOW_TOAST,
  UPDATE_PERMISSIONS,
  SHOW_ERROR_PAGE,
  HIDE_ERROR_PAGE,
  MULTIPLE_TAB_DETECTED,
} from "../constants/ActionTypes";

export const showToast = (
  payload: PartiallyOptional<IAlertToastProps, "onDismissCallBack">,
) => ({
  type: SHOW_TOAST,
  payload: {
    toast: {
      enable: true,
      data: payload,
    },
  },
});

export const hideToast = () => ({
  type: HIDE_TOAST,
});

export const showErrorPageAction = (payload: IErrorPageProps) => ({
  type: SHOW_ERROR_PAGE,
  payload: {
    errorPage: payload,
  },
});

export const hideErrorPageAction = () => ({
  type: HIDE_ERROR_PAGE,
});

export const multipleTabDetectedAction = (isMultipleTabDetected: boolean) => ({
  type: MULTIPLE_TAB_DETECTED,
  payload: {
    multipleTabDetected: isMultipleTabDetected,
  },
});

export const updateAudio = (isAudioEnabled: boolean) => ({
  type: UPDATE_PERMISSIONS,
  payload: {
    isAudioEnabled,
  },
});

export const updateVideo = (isVideoEnabled: boolean) => ({
  type: UPDATE_PERMISSIONS,
  payload: {
    isVideoEnabled,
  },
});

export const updateLocalStream = (isLocalFeedRunning: boolean) => ({
  type: UPDATE_PERMISSIONS,
  payload: {
    isLocalFeedRunning,
  },
});

export const updateVideoPermissionError = (
  isErrorInVideoPermission: boolean,
) => ({
  type: UPDATE_PERMISSIONS,
  payload: {
    isErrorInVideoPermission,
  },
});

export const updateAudioPermissionError = (
  isErrorInAudioPermission: boolean,
) => ({
  type: UPDATE_PERMISSIONS,
  payload: {
    isErrorInAudioPermission,
  },
});

export const updateVideoStreamingEnded = (isVideoStreamingEnded: boolean) => ({
  type: UPDATE_PERMISSIONS,
  payload: {
    isVideoStreamingEnded,
  },
});

export const updateAudioStreamingEnded = (isAudioStreamingEnded: boolean) => ({
  type: UPDATE_PERMISSIONS,
  payload: {
    isAudioStreamingEnded,
  },
});

export const setUserJoinLeaveNotification = (
  userJoinLeaveNotification: string | null,
) => ({
  type: SET_USER_JOIN_LEAVE_NOTIFICATION,
  payload: {
    userJoinLeaveNotification,
  },
});

export const setWhitelabelStatus = (whitelabelingEnabled: boolean) => ({
  type: SET_WHITE_LABEL_ENABLED,
  payload: {
    whitelabelingEnabled,
  },
});
